import { render, staticRenderFns } from "./TopSection.vue?vue&type=template&id=02845eb3&scoped=true"
import script from "./TopSection.vue?vue&type=script&lang=ts"
export * from "./TopSection.vue?vue&type=script&lang=ts"
import style0 from "./TopSection.vue?vue&type=style&index=0&id=02845eb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02845eb3",
  null
  
)

export default component.exports